import script from "./CheckupCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckupCard.vue?vue&type=script&setup=true&lang=js"

import "./CheckupCard.vue?vue&type=style&index=0&id=7fba78b1&lang=scss&scoped=true"

import exportComponent from "/home/nodeapps/vitamins/edna/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fba78b1"]])

export default __exports__